// language=GraphQL
export const ALL_DESTINATIONS_BLOCKS_QUERY = `query Query($withDestinations: Boolean = false) {
  destinationsBlocks: cmsDestinationsBlocks {
    id
    destinations @include(if: $withDestinations) {
      id
      name
      entryRequirements
      medicalInformation
      language
      timeShift
      climate
      currency
    }
  }
}`

// language=GraphQL
export const SINGLE_DESTINATIONS_BLOCK_QUERY = `query Query($id: ID!, $withDestinations: Boolean = false) {
  destinationsBlock: cmsDestinationsBlock(id: $id) {
    id
    destinations @include(if: $withDestinations) {
      id
      name
      entryRequirements
      medicalInformation
      language
      timeShift
      climate
      currency
    }
  }
}`

// language=GraphQL
export const CREATE_DESTINATIONS_BLOCK_MUTATION = `
  mutation Mutation($input: CreateCmsDestinationsBlockInput, $withDestinations: Boolean = false) {
    destinationsBlock: createCmsDestinationsBlock(input: $input) {
      id
      destinations @include(if: $withDestinations) {
        id
        name
        entryRequirements
        medicalInformation
        language
        timeShift
        climate
        currency
      }
    }
  }`

// language=GraphQL
export const UPDATE_DESTINATIONS_BLOCK_MUTATION = `
  mutation Mutation($input: UpdateCmsDestinationsBlockInput, $withDestinations: Boolean = false) {
    destinationsBlock: updateCmsDestinationsBlock(input: $input) {
      id
      destinations @include(if: $withDestinations) {
        id
        name
        entryRequirements
        medicalInformation
        language
        timeShift
        climate
        currency
      }
    }
  }`

// language=GraphQL
export const DELETE_DESTINATIONS_BLOCK_MUTATION = `
  mutation Mutation($input: DeleteCmsDestinationsBlockInput) {
    deleteCmsDestinationsBlock(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_DESTINATIONS_BLOCK_MUTATION = `
  mutation Mutation($input: DeleteCmsDestinationsBlockInput) {
    forceDeleteCmsDestinationsBlock(input: $input) {
      success
    }
  }`

// language=GraphQL
export const ADD_DESTINATIONS_BLOCK_DESTINATIONS_MUTATION = `
  mutation Mutation($input: addCmsDestinationsBlockDestinationsInput) {
    addCmsDestinationsBlockDestinations(input: $input) {
      id
      destinationIds
    }
  }`

// language=GraphQL
export const REMOVE_DESTINATIONS_BLOCK_DESTINATIONS_MUTATION = `
  mutation Mutation($input: removeCmsDestinationsBlockDestinationsInput) {
    removeCmsDestinationsBlockDestinations(input: $input) {
      id
      destinationIds
    }
  }`

// language=GraphQL
export const CREATE_DESTINATIONS_BLOCK_DESTINATIONS_MUTATION = `
  mutation Mutation($input: createCmsDestinationsBlockDestinationsInput) {
    createCmsDestinationsBlockDestinations(input: $input) {
      id
      destinationIds
    }
  }`

// language=GraphQL
export const DELETE_DESTINATIONS_BLOCK_DESTINATIONS_MUTATION = `
  mutation Mutation($input: deleteCmsDestinationsBlockDestinationsInput) {
    deleteCmsDestinationsBlockDestinations(input: $input) {
      id
      destinationIds
    }
  }`

// language=GraphQL
export const UPDATE_DESTINATIONS_BLOCK_DESTINATIONS_ORDER_MUTATION = `
  mutation Mutation($input: updateCmsDestinationsBlockDestinationsOrderInput) {
    updateCmsDestinationsBlockDestinationsOrder(input: $input) {
      id
      destinationIds
    }
  }`
